/**
 * One-shot Service Worker cleanup.
 *
 * An earlier PWA build of the member portal registered a SW with scope
 * `/`, which then intercepted `/studio/` navigations and served stale
 * cached member HTML when the admin app started shipping at `/studio/`.
 * Both apps now call `cleanupStaleServiceWorkers()` on startup to
 * unregister anything left behind. Safe to remove once we've shipped a
 * couple of versions without PWA and there's nothing stale in the wild.
 */
export async function cleanupStaleServiceWorkers(): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    if (!regs.length) return;
    await Promise.all(regs.map((r) => r.unregister().catch(() => false)));
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k).catch(() => false)));
    }
    // eslint-disable-next-line no-console
    console.info('[fitboxx] unregistered', regs.length, 'stale service workers');
  } catch (e) {
    // Don't let cleanup block app boot.
    // eslint-disable-next-line no-console
    console.warn('[fitboxx] SW cleanup failed:', e);
  }
}
